import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import esTranslations from './locales/es.json';
import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';
import esVisitors from './locales/visitors.es.json';
import enVisitors from './locales/visitors.en.json';
import frVisitors from './locales/visitors.fr.json';

// Obtener el idioma del localStorage o usar español por defecto
const savedLanguage = localStorage.getItem('i18nextLng') || 'es';
// Asegurar que el idioma sea válido
const validLanguage = ['es', 'en', 'fr'].includes(savedLanguage) ? savedLanguage : 'es';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: { ...esTranslations, visitors: esVisitors },
      },
      en: {
        translation: { ...enTranslations, visitors: enVisitors },
      },
      fr: {
        translation: { ...frTranslations, visitors: frVisitors },
      },
    },
    fallbackLng: 'es',
    lng: validLanguage,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

// Asegurar que el idioma se guarde en localStorage
if (localStorage.getItem('i18nextLng') !== validLanguage) {
  localStorage.setItem('i18nextLng', validLanguage);
}

// Escuchar cambios de idioma y actualizar localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;

